require('./editReport.style.scss');
// const Report = require('../../model/Report');

const _ = require('lodash');
const { permissions } = require('../../../../constants/permissions');

class EditReportsController {
    constructor($scope, $filter, $timeout, $element, $compile, $document, reportsPersistence, styleService, notificationService, utilsService, docsService, config, iamPersistenceService) {
        this.$scope = $scope;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$element = $element;
        this.$compile = $compile;
        this.$document = $document;
        this.notificationService = notificationService;
        this.utilsService = utilsService;
        this.docsService = docsService;
        this.reportsPersistence = reportsPersistence;
        this.iamPersistenceService = iamPersistenceService;
        this.inRole = utilsService.isUserRole();
        this.configGeneral = config;

        this.$scope.$on("export-data", (event, data) => {
            this.exportReportData = data;
        });

        this.predefinedYValues = [
            { name: 'vm_name', key: 'vm_name', type: 'string' },
        ];
        this.predefinedXValues = [];

        this.hideTotalsArray = ['None'];
        this.cssClassesTotals = ['.pvtGrandTotal', '.pvtTotalLabel', '.pvtTotal'];
        this.tableRenderers = ['Table', 'Heatmap', 'Table Barchart', 'Col Heatmap', 'Row Heatmap'];

        this.barChartColor = styleService.getAllChartColors();

        this.timeRangeOptions = [
            { id: 1, label: this.$filter('translate')('report.view.timeRange.option.all.label'), detail: this.$filter('translate')('report.view.timeRange.option.all.label'), value: 'ALL' },
            { id: 2, label: this.$filter('translate')('report.view.timeRange.option.last7days.label'), detail: this.$filter('translate')('report.view.timeRange.option.last7days.label'), value: 'LAST7DAYS' },
            { id: 2, label: this.$filter('translate')('report.view.timeRange.option.last48h.label'), detail: this.$filter('translate')('report.view.timeRange.option.last48h.label'), value: 'LAST48H' },
            { id: 3, label: this.$filter('translate')('report.view.timeRange.option.last24h.label'), detail: this.$filter('translate')('report.view.timeRange.option.last24h.label'), value: 'LAST24H' },
            { id: 4, label: this.$filter('translate')('report.view.timeRange.option.previousMonth.label'), detail: this.$filter('translate')('report.view.timeRange.option.previousMonth.label'), value: 'PREVIOUSMONTH' },
            { id: 5, label: this.$filter('translate')('report.view.timeRange.option.previousWeek.label'), detail: this.$filter('translate')('report.view.timeRange.option.previousWeek.label'), value: 'PREVIOUSWEEK' },
            { id: 6, label: this.$filter('translate')('report.view.timeRange.option.previousDay.label'), detail: this.$filter('translate')('report.view.timeRange.option.previousDay.label'), value: 'PREVIOUSDAY' }
        ];

        this.exportTypes = [
            { id: 1, title: this.$filter('translate')('report.view.download.option.pdf'), format: 'PDF' },
            { id: 2, title: this.$filter('translate')('report.view.download.option.png'), format: 'PNG' },
            { id: 3, title: this.$filter('translate')('report.view.download.option.csv'), format: 'CSV' }
        ];

        this.versionOptions = [];
        this.initVersionOptions();

        this.helpId = 'reports-create';

        this.isMini = false;
        this.initLayout = false;
        this.parameterChange = false;
        this.saveAs = false;
        this.versionDescription = '';

        this.timeRange = this.timeRangeOptions[3];
        this.versionSelected = this.versionOptions[0];
        this.chartReady = false;
        this.emptyData = false;
        this.dataTags = {};
        this.haveData = false;
        this.versionChange = false;

        this.$document.keyup((e) => {
            if (e.keyCode === 27) {
                this.onClose();
            }
        });
    }

    onHelp() {
        this.docsService.openHelp(this.helpId);
    }

    $onInit() {
        this.$scope.$watch(() => this.showView, (value) => {
            if (!value) return;
            if (value) {
                this.$timeout(() => {
                    this.initLayout = true;
                    this.reportsPersistence.getReportTags().then(res => {
                        this.predefinedTagValues = res[0].tags;
                        this.filteringMode = res[0].filtering_mode;
                        this.initView();
                    })
                }, 200);
            }
        });

        this.$scope.$watch(() => this.timeRange, (value) => {
            if (value && this.showView && !this.initLayout) {
                // this.updateDataTags(this.reportConfig);
                if (!this.version) {
                    this.updateReportsData();
                }
            }
        });

        this.$scope.$watch(() => this.reportConfig, (value) => {
            if (value && this.showView && !this.initLayout && !this.versionView) {
                // this.updateDataTags(this.reportConfig);
                this.updateReportsData();
            }
            this.versionView = false;
        });

        this.$scope.$watch(() => this.versionSelected, (value) => {
            if (value && this.showView && !this.initLayout) {
                this.updateSelection(value);
                this.updateVersionData();
            }
        });

        this.$document.on('mousedown', (e) => {
            if (e.target.id !== 'downloadIcon1' || e.target.id !== 'downloadIcon2' && !this.$element[0].contains(e.target)) {
                this.isPopupVisible = false
            }
        });

        this.toggleMenu = () => this.isPopupVisible = !this.isPopupVisible;
    }

    initVersionOptions() {
        this.versionOptions = [
            { id: 1, label: this.$filter('translate')('report.view.version.option.current.label'), detail: this.$filter('translate')('report.view.version.option.current.label'), value: 'current' }
        ];
    }

    initView() {
        this.btnTitle = this.report ? this.view || this.version ? this.$filter('translate')('report.view.generate.button') : this.$filter('translate')('report.view.save.button') :
            this.$filter('translate')('report.view.save.button');
        this.reportViewTitleName = this.report ? this.report.name : '';
        this.reportViewTitleVersion = this.version ? this.$filter('localizeDate')(this.version.created, 'shortSec') : this.$filter('translate')('report.view.version.title.undefined');
        this.reportViewTitleTimeRange = this.report ? this.getTimeRange(this.timeRangeOptions, this.report.parameters.timeRange) : '';
        this.reportViewTitleAggregation = this.details ? this.getAggregatorName(this.details, this.$filter('translate')('report.subTable.details.aggregation.label')) : '';
        this.isPredefined = this.report ? this.report.predefined : false;
        this.versionDescription = '';
        this.chartReady = false;
        this.emptyData = false;

        this.helpId = this.view ? 'reports-view' : 'reports-create';

        if (this.report) {
            this.reportName = this.report.name;
            this.reportDescription = this.report.description;
            this.timeRange = this.getTimeRange(this.timeRangeOptions, this.reportViewTitleTimeRange.value);
            this.reportAggregation = this.reportViewTitleAggregation.value;
        } else {
            document.getElementById("inputReportName").focus();
            this.reportName = '';
            this.reportDescription = '';
            this.timeRange = this.timeRangeOptions[3];
            this.reportAggregation = ''
        }

        if (!this.version) {
            this.getReportConfig();
        } else {
            this.versionView = true;
            this.getVersionData();
        }
    }

    getTimeRange(array, value) {
        for (let i = 0; i < array.length; i++) {
            if (array[i].value === value) {
                return array[i];
            }
        }
    }

    getAggregatorName(array, value) {
        for (let i = 0; i < array.length; i++) {
            if (array[i].detail === value) {
                return array[i];
            }
        }
    }

    getVersion(array, version) {
        for (let i = 0; i < array.length; i++) {
            if (array[i].value === version.uuid) {
                return array[i];
            }
        }
    }

    updateSelection(item) {
        for (let i = 0; i < this.versionOptions.length; i++) {
            this.versionOptions[i].selected = false;
            if (this.versionOptions[i].value === item.value) {
                this.versionOptions[i].selected = true;
            }
        }
    }

    updateDataTags(config) {
        this.dataTags.tags = config.cols.concat(config.rows).concat(config.vals); // separate aggregation from data tags
        this.dataTags.tags = [...new Set(this.dataTags.tags)]; // removes duplicates in array
        this.dataTags.tags.forEach((c, i) => {
            if (this.dataTags.tags[i] === 'Job duration') {
                this.dataTags.tags[i] = this.toServerCase('Duration s')
            } else if (this.dataTags.tags[i] === 'Compliance status') {
                this.dataTags.tags[i] = this.toServerCase('Compliancy status')
            } else if (this.dataTags.tags[i] === 'Compliance reason') {
                this.dataTags.tags[i] = this.toServerCase('Compliancy reason')
            } else if (this.dataTags.tags[i] === 'Owner') {
                this.dataTags.tags[i] = this.toServerCase('Tenant name')
            } else {
                this.dataTags.tags[i] = c.key ? c.key : this.toServerCase(c);
            }
        });
    }


    getReportConfig() {
        this.busy = true;
        if (this.report) {
            this.reportsPersistence.getReport(this.report).then(reportsData => {
                this.reportObject = reportsData[0];
                this.reportConfig = reportsData[0].config;
                if (reportsData[0].versions.length) {
                    this.versionOptions.push.apply(this.versionOptions, reportsData[0].versions.map((item, i) => {
                        return { id: i + 1, label: this.$filter('localizeDate')(item['created'], 'shortSec'), value: item['uuid'], created: item['created'], name: item['name'] }
                    }));
                }
                this.updateSelection(this.versionSelected);
                // this.formatResponseConfig();
                this.reportConfig.showUI = !this.view ? !this.version : false;
                this.getReportsData();
            }, err => {
                this.reportConfig = {};
            });
        } else {
            this.reportConfig = {};
            this.getReportsData();
        }
    }

    getReportsData() {
        this.busy = true;
        let predefinedConfig = {};
        if (!this.view && !this.report) {
            predefinedConfig = { cols: this.predefinedYValues, rows: this.predefinedXValues, vals: [] };
        } else {
            predefinedConfig = this.reportConfig;
        }
        this.updateDataTags(predefinedConfig);

        // const reportUuid = this.view || this.report ? this.report : null;
        this.reportsPersistence.getReportData(this.timeRange.value, null, this.dataTags).then(reportData => {
            this.reportData = reportData.data.entities[0] ? reportData.data.entities[0] : [];
            if (!this.report) {
                this.reportConfig.rows = this.predefinedYValues;
                this.reportConfig.cols = this.predefinedXValues;
                this.reportConfig.rendererName = 'Table';
                this.reportConfig.vals = [];
                this.reportConfig.aggregatorName = 'None';
                this.reportAggregation = { id: 1, label: this.$filter('translate')('ctxPivotTable.aggregation.none'), detail: this.$filter('translate')('ctxPivotTable.aggregation.none'), value: 'None' }
            }

            if (reportData.data.message.type !== 'OK') {
                this.notificationService.pop(reportData.data.message);
            }
            this.initLayout = false;
        }, err => {
            this.busy = false;
            this.reportData = {};
        });
    }

    updateReportsData(clearPool = false) {
        if (this.reportConfig) { this.updateDataTags(this.reportConfig) }

        if (Object.keys(this.dataTags).length !== 0) {
            this.busy = true;
            // let renderers = $.extend($.pivotUtilities.renderers, $.pivotUtilities.c3_renderers);
            this.reportsPersistence.getReportData(this.timeRange.value, null, this.dataTags).then(
                (reportData) => {
                    this.reportData = reportData.data.entities[0] ? reportData.data.entities[0] : [];
                    this.reportViewTitleTimeRange = this.getTimeRange(this.timeRangeOptions, this.timeRange.value);
                    // this.formatResponseData();
                    this.parameterChange = true;
                    if (reportData.data.entities.length === 0) {
                        this.haveData = false;
                    } else {
                        this.haveData = true;
                    }

                    let configObject = this.updateReportConfig;
                    if (!this.haveData && reportData.data.entities.length) {
                        configObject = this.reportConfig;
                        this.updateReportConfig = JSON.parse(JSON.stringify(this.reportConfig));
                        this.haveData = true;
                        // }
                    }

                    if (reportData.data.message.type !== 'OK') {
                        this.notificationService.pop(reportData.data.message);
                    }
                },
                (err) => {
                    this.busy = false;
                    this.reportData = {};
                }
            );
        }
    }

    getVersionData() {
        this.busy = true;
        this.reportsPersistence.getReportVersion(this.report, this.version.uuid).then(reportItem => {
            this.reportViewTitleTimeRange = this.getTimeRange(this.timeRangeOptions, reportItem.data.entities[0].parameters.timeRange);
            this.reportObject = reportItem.data.entities[0];
            this.reportData = this.reportObject.data;
            // this.formatResponseData();
            this.reportConfig = this.reportObject.config;
            this.reportConfig.showUI = !this.version;
            if (this.report.versions.length) {
                this.versionOptions.push.apply(this.versionOptions, this.report.versions.map((item, i) => {
                    return { id: i + 1, label: this.$filter('localizeDate')(item['created'], 'shortSec'), value: item['uuid'], created: item['created'], name: item['name'] }
                }));
                this.versionSelected = this.getVersion(this.versionOptions, this.version);
                this.versionDescription = reportItem.data.entities[0].description;
                this.updateSelection(this.versionSelected);
            }
            if (reportItem.data.message.type !== 'OK') {
                this.notificationService.pop(reportItem.data.message);
            }

            this.$timeout(() => {
                this.initLayout = false;
            }, 200);

        }, err => {
            this.busy = false;
            this.reportData = {};
            this.reportConfig = {};
        })
    }

    updateVersionData() {
        if (this.versionSelected.value === 'current') {
            this.versionDescription = '';
            this.updateReportsData();
        } else {
            this.busy = true;
            this.versionView = true;
            this.reportsPersistence.getReportVersion(this.report, this.versionSelected.value).then(
                (reportItem) => {
                    this.reportViewTitleTimeRange = this.getTimeRange(this.timeRangeOptions, reportItem.data.entities[0].parameters.timeRange);

                    this.reportConfig = reportItem.data.entities[0].config;
                    this.reportConfig.showUI = !this.version;
                    // this.formatResponseConfig();
                    this.reportData = reportItem.data.entities[0].data;
                    if (reportItem.data.message.type !== 'OK') {
                        this.notificationService.pop(reportItem.data.message);
                    }
                    this.versionDescription = reportItem.data.entities[0].description;
                    // this.formatResponseData();
                },
                (err) => {
                    this.busy = false;
                    this.reportData = {};
                    this.reportConfig = {};
                }
            );
        }
    }

    submitAction() {
        const reportUpdateData = {
            name: this.reportName,
            description: this.reportDescription,
            parameters: { timeRange: this.timeRange.value },
            config: this.reportConfig
        };
        if (this.report && !this.saveAs) {
            if (this.view || this.version) {
                const data = {
                    description: this.versionDescription
                };
                this.busy = this.reportsPersistence.createReportVersion(this.report, data)
                    .then(res => {
                        this.busy = false;
                        this.notificationService.pop(res.data.message);
                        this.onReportUpdate({ report: this.reportObject });
                    }, err => {
                        this.busy = false;

                    });
            } else {
                this.reportDataCopy = angular.copy(reportUpdateData)

                this.reportDataCopy.config.cols = reportUpdateData.config.cols.map(obj => {
                    return obj.key
                })

                this.reportDataCopy.config.rows = reportUpdateData.config.rows.map(obj => {
                    return obj.key
                })

                this.reportDataCopy.config.vals.forEach((v, i) => { this.reportDataCopy.config.vals[i] = this.toServerCase(v) });
                this.reportsPersistence.updateReport(this.reportObject, this.reportDataCopy).then((resp) => {
                    this.busy = false;
                    this.showView = false;
                    this.dataTags = {};
                    this.reportData = {};
                    this.initLayout = false;
                    this.parameterChange = false;
                    this.chartReady = false;
                    this.timeRange = this.timeRangeOptions[3];
                    this.notificationService.pop(resp.data.message);
                    this.onReportUpdate({ report: this.reportDataCopy });
                }, err => {
                    this.busy = false;
                    // this.reportData = {};
                    // this.reportConfig = {};
                });
            }
        } else {
            this.reportDataCopy = angular.copy(reportUpdateData)

            this.reportDataCopy.config.cols = reportUpdateData.config.cols.map(obj => {
                return obj.key
            })

            this.reportDataCopy.config.rows = reportUpdateData.config.rows.map(obj => {
                return obj.key
            })

            this.reportDataCopy.config.vals.forEach((v, i) => { this.reportDataCopy.config.vals[i] = this.toServerCase(v) });
            this.reportsPersistence.createReport(this.reportDataCopy).then((resp) => {
                this.busy = false;
                this.showView = false;
                this.dataTags = {};
                this.reportData = {};
                this.initLayout = false;
                this.parameterChange = false;
                this.chartReady = false;
                this.saveAs = false;
                this.timeRange = this.timeRangeOptions[3];
                this.notificationService.pop(resp.data.message);
                this.onReportUpdate({ report: this.reportDataCopy });
            }, err => {
                this.busy = false;
                this.saveAs = false;
            });
        }
    }

    disableSaveButton() {
        return (this.dialogForm && !this.dialogForm.$valid) || (!this.view && this.isPredefined) || ((this.version || this.view) && this.versionSelected.value !== 'current') || !this.inRole.admin || ((this.reportConfig && this.reportConfig.cols && this.reportConfig.cols.length === 0) && (this.reportConfig && this.reportConfig.rows && this.reportConfig.rows.length === 0));
    }

    disableSaveAsButton() {
        return (this.dialogForm && !this.dialogForm.$valid) || ((this.version || this.view) && this.versionSelected.value !== 'current') || !this.inRole.admin || ((this.reportConfig && this.reportConfig.cols && this.reportConfig.cols.length === 0) && (this.reportConfig && this.reportConfig.rows && this.reportConfig.rows.length === 0));
    }

    hideSaveButton() {
        return  this.view && !this.iamPersistenceService.hasPermissions(permissions.REPORT_VERSION_CREATE)
    }

    onClose() {
        this.showView = false;
        this.dataTags = {};
        this.initLayout = false;
        this.parameterChange = false;
        this.timeRange = this.timeRangeOptions[3];
        this.updateReportConfig = {};
        this.reportConfig = {};
        this.reportData = {};
        this.versionSelected = this.versionOptions[0];
        this.versionDescription = '';
        this.chartReady = false;
        this.saveAs = false;
        this.onClosed()
        // this.isEditMode = false;
        this.initVersionOptions();
    }

    cloneReport() {
        this.saveAs = true;
        this.submitAction();
    }

    exportReport(format) {

        this.notificationService.pop({ title: this.$filter('translate')('reports.export.start'), details: this.$filter('translate')('reports.export.start.details'), type: "in_progress" });

        const data = {
            reportUuid: this.report.uuid,
            versionUuid: this.versionSelected.value !== 'current' ? this.versionSelected.value : 'default',
            format: format,
            lang: window.navigator.userLanguage || window.navigator.language || 'en',
            reportData: this.exportReportData,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
        };

        this.reportsPersistence.exportReportVersion(this.report, data.versionUuid, data)
            .then(res => {
                let fileName = this.report.name + ' - ' + this.versionSelected.label + '.' + data.format.toLowerCase();
                this.utilsService.saveData(res.data, fileName, this.getFileType(data.format));
                if (res.data.message.type !== 'OK') {
                    this.notificationService.pop(res.data.message);
                }
            }, err => {
                this.notificationService.pop(err.data.message);
            })
            .finally(() => {
                this.showModal = false;
            });
    }

    getFileType(type) {
        switch (type) {
            case 'CSV': return 'text/csv'; break;
            case 'PDF': return 'application/pdf'; break;
            case 'PNG': return 'image/png'; break;
        }
    }

    formatResponseConfig() {
        this.reportConfig.cols.forEach((c, i) => { this.reportConfig.cols[i] = this.toSentanceCase(c) });
        this.reportConfig.rows.forEach((r, i) => { this.reportConfig.rows[i] = this.toSentanceCase(r) });
        this.reportConfig.vals.forEach((v, i) => { this.reportConfig.vals[i] = this.toSentanceCase(v) });
    }

    formatServerData() {
        this.newReportConfig.cols.forEach((c, i) => { this.newReportConfig.cols[i] = this.toServerCase(c) });
        this.newReportConfig.rows.forEach((r, i) => { this.newReportConfig.rows[i] = this.toServerCase(r) });
        this.newReportConfig.vals.forEach((v, i) => { this.newReportConfig.vals[i] = this.toServerCase(v) });
    }

    toSentanceCase(str) {
        str = str.toLowerCase().split('_');
        for (let i = 0; i < str.length; i++) {
            str[i] = i === 0 ? str[i].charAt(0).toUpperCase() + str[i].slice(1) : str[i];
            if (str[i] === 'Vm' || str[i] === 'uuid' || str[i] === 'Ip') {
                str[i] = str[i].toUpperCase();
            }
        }
        return str.join(' ')
    }

    toServerCase(str) {
        str = str.toLowerCase().split(' ');
        if (str[str.length - 1] === '') {
            str.splice(-1, 1)
        }
        return str.join('_')
    }

    //NOTE: The following functions format<dataType> are needed for this.derivedAttributes.
    //We will keep them until better solution is found, to replace the current handling of this.derivedAttributes
    formatUnits(property) {
        return (record) => {
            if (record[property] || record[property] === 0) {
                const locale = window.navigator.userLanguage || window.navigator.language || 'en';
                // const result = this.utilsService.fromBytesTo(record[property], 'mib');
                const result = record[property].toLocaleString(locale);
                return result == 0 ? '0' : result;
                // } else if (this.numericalOptionsOrig.indexOf(property) !== -1) {
                //     return 'n/a';
            } else {
                return '';
            }
        }
    }

    formatTime(property) {
        return (record) => {
            if (record[property]) {
                const result = new Date(record[property] * 1000).toISOString().substr(11, 8);
                return result === 0 ? '' : result;
            }
        }
    }

    formatName(property) {
        return (record) => {
            if (record[property]) {
                return record[property];
            }
        }
    }

    formatDate(property) {
        return (record) => {
            if (record[property]) {
                let result = 0;
                if (property === 'Start time d' || property === 'Activity time d') {
                    result = this.$filter('localizeDate')(moment.utc(record[property]).toDate(), 'short', false);
                    result = this.getDateDiff(result, record['Start time '], record['Start time']);
                } else {
                    result = this.$filter('localizeDate')(moment.utc(record[property]).toDate(), 'shortSec');
                }
                return result === 0 ? '' : result;
            } else {
                return '';
            }
        }
    }

    formatLocaleTime(property) {
        return (record) => {
            if (record[property] != null) {
                moment.locale(window.navigator.userLanguage || window.navigator.language || 'en');
                return moment(record['Start time '], 'l LTS').hour();
            } else {
                return '';
            }
        }
    }

    formatPercent(property) {
        return (record) => {
            if ($.isNumeric(record[property])) {
                return (record[property] * 100).toFixed(0) + "%";
            } else {
                return record[property] || '';
            }
        }
    }

    getDateDiff(fromDate, toDate, originalDate) {
        moment.locale(window.navigator.userLanguage || window.navigator.language || 'en');
        const dateDiff = moment(toDate, 'l LTS').diff(moment(fromDate, 'l LT'), 'days');
        if (dateDiff !== 0) {
            return this.$filter('localizeDate')(moment.utc(originalDate).toDate(), 'short', false);
        } else {
            return fromDate;
        }
    }

    isDownloadReportDisabled() {
        return !this.iamPersistenceService.hasPermissions(permissions.REPORT_VIEW_EXPORT);
    }
}

const editReportComponent = {
    controller: EditReportsController,
    template: require('./editReport.template.html'),
    bindings: {
        report: '<',
        onReportUpdate: '&',
        version: '<',
        details: '<',
        view: '<',
        isEditMode: '<',
        showView: '=',
        onClosed: '&'
    }
};

EditReportsController.$inject = ['$scope', '$filter', '$timeout', '$element', '$compile', '$document', 'reportsPersistence', 'styleService', 'notificationService', 'utilsService', 'docsService', 'config', 'iamPersistenceService'];

module.exports = editReportComponent;



// WEBPACK FOOTER //
// ./src/azurebackup/views/reports/dialogs/editReport/editReport.component.js